// Shared lead-table display constants so the /leads inbox and /leads/search
// results tables render the same text for the same state (surfaces that must
// agree).

// For an owner-occupied row the single org is shown in the Tenant column (it's
// the occupier), and the Landlord column carries this literal instead of
// repeating the same name. Used by both lead tables.
export const OWNER_OCCUPIED_LANDLORD_LABEL = "Owner occupied";

// Auto-pick confidence gate. A top match at or below this is still shown, but
// never counts as SELECTED: the operator has to choose it deliberately, so a
// weak guess can't ride a "Save & next" into a promoted lead.
//
// Every surface that decides whether a match is the row's pick must apply this,
// or they disagree about what the tenant/landlord IS: the right panel's
// default-pick, the results-table Tenant/Landlord cells, and the promote
// payload builder (which previously defaulted to the ungated top match, so a
// below-gate match the panel showed as "none selected" was persisted anyway).
export const AUTO_PICK_CONFIDENCE_GATE = 70;

// Landlord auto-picks at a LOWER bar than tenant, deliberately. Landlord
// confidence is dominated by registry/deed evidence that is frequently absent or
// polygon-mismatched, so the useful band starts lower; a 50%+ deed is worth
// pre-selecting for the operator to confirm rather than leaving unpicked.
// Inclusive - 50 itself auto-picks.
export const AUTO_PICK_LANDLORD_CONFIDENCE_GATE = 50;

export const isAutoPickable = (
  confidence: number | null | undefined
): boolean => (confidence ?? 0) > AUTO_PICK_CONFIDENCE_GATE;

export const isLandlordAutoPickable = (
  confidence: number | null | undefined
): boolean => (confidence ?? 0) >= AUTO_PICK_LANDLORD_CONFIDENCE_GATE;

// The option COUNT the right panel would show. The panel renders DEDUPED rows
// (dedupeOrgRows, keyed on lowercased displayName), so a raw list length
// disagrees with it - the results table said "5 options" where the panel said
// 3. Same key, so the two counts agree by construction.
export const distinctOrgNameCount = (
  names: (string | null | undefined)[]
): number =>
  new Set(
    names
      .filter((n): n is string => !!n && n.trim() !== "")
      .map((n) => n.toLowerCase())
  ).size;
